import { useSyncExternalStore } from "react";

export type ServixUserType = "Gerente" | "Proveedor" | "Cliente" | "Soporte";

export type ServixSession = {
	user: {
		id: number;
		email: string;
		type_user: ServixUserType | null;
		name: string | null;
	};
};

let _current: ServixSession | null = null;
const _listeners = new Set<() => void>();

function _notify(): void {
	_listeners.forEach((fn) => fn());
}

export function getSession(): ServixSession | null {
	return _current;
}

export function setSession(session: ServixSession): void {
	_current = session;
	_notify();
}

export function clearSession(): void {
	_current = null;
	localStorage.removeItem("local_orders");
	_notify();
}

function subscribe(callback: () => void): () => void {
	_listeners.add(callback);
	return () => _listeners.delete(callback);
}

export function useSession(): ServixSession | null {
	return useSyncExternalStore(subscribe, getSession, () => null);
}
